import { FC, useMemo } from "react"
import { ColumnConfig } from "@app/shared/waffles";
import { Waffles } from "@app/shared/waffles/Waffles";
import { ProviderHubSpecialtyView, SpecialtyCountModel } from "@app/projects/network-assessment/provider-hub/interfaces";
import { Accordion } from "@app/shared/Accordion";
import { formatSpecialtyWithCode } from "@app/projects/network-assessment/provider-hub/utility";

interface ProviderHubSpecialtyViewProps {
  specialties: SpecialtyCountModel[];
}

export const ProviderHubSpecialty: FC<ProviderHubSpecialtyViewProps> = (props: ProviderHubSpecialtyViewProps) => {

/* oxlint-disable sort-keys */
    const providerHubSpecialtyColumnConfig: ColumnConfig = {
        specialty: {
            displayText: "Specialty Group",
            sizeContentToFit: true,
            testId: "provider-hub_specialty-table-specialty",
            wrapContent: true,
            noResize: true
        },
        providerCount: {
            displayText: "Number of Providers",
            sizeContentToFit: true,
            testId: "provider-hub_specialty-table-provider-count",
            wrapContent: true,
            noResize: true
        }
    }

    const providerHubSpecialtyTableData: ProviderHubSpecialtyView[] = useMemo<ProviderHubSpecialtyView[]>(() => {

        let data: ProviderHubSpecialtyView[] = [];
        data = props.specialties.slice().sort((a,b) => b.count - a.count).map((specialty, index) => {
            return {
                key: index.toString(),
                specialty: formatSpecialtyWithCode(specialty),
                providerCount: specialty.count
            }
        });

        return data;

    }, [props.specialties]);
    /* oxlint-enable sort-keys */

  return (
    <Accordion title="Specialty Groups" testId="provider-hub__specialty-accordion" defaultOpen={true}>
      <Waffles<ProviderHubSpecialtyView>
          columns={providerHubSpecialtyColumnConfig}
          data={providerHubSpecialtyTableData}
          totalNumberOfRecords={props.specialties.length}
          enablePagination={true}
          emptyTableMessage="No Specialty Groups found."
          fullWidth={true}
          testId="provider-hub__specialty-table"
      />
    </Accordion>
  )
};